import { usePromptHistoryNavigation } from '#pplx/frontend/apps/ask/ask-input/ask-input-core/hooks/usePromptHistoryNavigation.js';
import { useCallback, useMemo } from 'react';
export function usePromptHistoryInputHandlers({ history, value, setValue, onChange, onSubmit, trackEvent, resetKey, }) {
    const promptHistoryNavigation = usePromptHistoryNavigation({
        history,
        value,
        setValue,
        trackEvent,
        resetKey,
    });
    const handleChange = useCallback((newInput, json) => {
        onChange(newInput, json);
        promptHistoryNavigation.notifyContentChanged(newInput);
    }, [onChange, promptHistoryNavigation]);
    const handleSubmit = useCallback((params) => {
        const didSubmit = onSubmit(params);
        if (didSubmit) {
            promptHistoryNavigation.notifySubmitted(params.query ?? '');
            promptHistoryNavigation.reset();
        }
        return didSubmit;
    }, [onSubmit, promptHistoryNavigation]);
    return useMemo(() => ({
        onChange: handleChange,
        onSubmit: handleSubmit,
        onKeyDown: promptHistoryNavigation.handleKeyDown,
    }), [handleChange, handleSubmit, promptHistoryNavigation.handleKeyDown]);
}
//# sourceMappingURL=usePromptHistoryInputHandlers.js.map